import { Phone, Mail, MapPin } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-primary text-primary-foreground py-12" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-12">
          <div>
            <h3 className="text-xl font-bold mb-4">Amjed Tours</h3>
            <p className="text-sm opacity-90">
              Your trusted car rental service across Pakistan. Explore the beauty of our country with comfort and style.
            </p>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm opacity-90">
              <li><a href="/cars" className="hover:text-accent transition-colors">Browse Cars</a></li>
              <li><a href="/blog" className="hover:text-accent transition-colors">Blog</a></li>
              <li><a href="/rent-a-car/islamabad" className="hover:text-accent transition-colors">Rent a Car Islamabad</a></li>
              <li><a href="/rent-a-car/lahore" className="hover:text-accent transition-colors">Rent a Car Lahore</a></li>
              <li><a href="/rent-a-car/karachi" className="hover:text-accent transition-colors">Rent a Car Karachi</a></li>
              <li><a href="/rent-a-car/peshawar" className="hover:text-accent transition-colors">Rent a Car Peshawar</a></li>
              <li><a href="/review-qr" className="hover:text-accent transition-colors">Review QR Card</a></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4">Contact Us</h4>
            <ul className="space-y-3 text-sm opacity-90">
              <li className="flex items-center gap-2" data-testid="footer-phone">
                <Phone className="w-4 h-4" />
                <span>0311-9951299</span>
              </li>
              <li className="flex items-center gap-2" data-testid="footer-email">
                <Mail className="w-4 h-4" />
                <span>amjedtours@gmail.com</span>
              </li>
              <li className="flex items-center gap-2" data-testid="footer-location">
                <MapPin className="w-4 h-4" />
                <span>Islamabad, Pakistan</span>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="mt-12 pt-6 border-t border-white/20 text-center text-sm opacity-75">
          <p>&copy; 2025 Amjed Tours. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};
